import React, {useState, useEffect} from "react";
import {connect} from 'react-redux';
//import ProgressBar from 'react-bootstrap/ProgressBar'
//import Table from 'react-bootstrap/Table';
//import Pagination from 'react-js-pagination';
import Pagination from 'react-bootstrap/Pagination';
//import Container from 'react-bootstrap/Container';
import Container from '@material-ui/core/Container';
import {useMediaQuery, useTheme} from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { withStyles } from '@mui/styles';
import {styled} from '@mui/material/styles';
//import { createTheme, ThemeProvider } from '@mui/material/styles';
//import Checkbox from '@mui/material/Checkbox';
//import Typography from '@material-ui/core/Typography';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Spinner from 'react-bootstrap/Spinner';
//import Button from 'react-bootstrap/Button';
//import Button from '@material-ui/core/Button';
import Button from '@mui/material/Button';
//import IconButton from '@material-ui/core/IconButton';
//import Icon from '@material-ui/core/Icon';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
//import Modal from 'react-bootstrap/Modal';
//import Modal from '@material-ui/core/Modal';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
//import PageItem from 'react-bootstrap/PageItem'
import { Redirect } from 'react-router-dom';
//import { NavLink, Link } from 'react-router-dom';
//import {LinkContainer} from 'react-router-bootstrap';
//import { Nav, NavItem} from "react-bootstrap";
//import DeleteModal from './DeleteModal';
import * as actions from '../store/actions/index';
import * as actionTypes from "../store/actions/actionTypes";
//import AddClientQuick from './AddClientQuick';
//import AddCircleRoundedIcon from '@material-ui/icons/AddCircleRounded';
//import { green } from '@material-ui/core/colors';
import Paper from '@material-ui/core/Paper';
import Card from '@material-ui/core/Card';
import CardHeader from '@mui/material/CardHeader';
//import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Divider from '@material-ui/core/Divider';
//import Collapse from '@material-ui/core/Collapse';
//import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
//import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';

//
import { forwardRef } from 'react';
import AddBox from '@material-ui/icons/AddBox';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
//

import moment from 'moment';
//import { MDBDataTable } from 'mdbreact';
//import MaterialTable from "material-table";
import MaterialTable from "@material-table/core";
import { ExportCsv, ExportPdf } from '@material-table/exporters';
//import {MTableToolbar} from "material-table";
import {MTableToolbar} from "@material-table/core";
import ArrowDownward from '@material-ui/icons/ArrowDownward';
//import DataTable from 'react-data-table-component';
//import TextField from '@material-ui/core/TextField';
//import { Form, Alert } from "react-bootstrap";
import QuickRenew from './QuickRenew';
//import DatatablePage from './DatatablePage';
//import ReactTable from './ReactTable';
import {purple} from "@mui/material/colors/index";

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    success: {
        color: theme.palette.getContrastText(purple[500])
    },
    header: {
        textAlign: 'left',
        spacing: 10,
    }
}));

//const StyledChip = withStyles({
//    //root: {
//    backgroundColor: 'red'// here you can do anything actually
//},
//    label: {
//        textTransform: 'capitalize',
//    },
//    fontSize: 12
//})(Chip);

const StyledChip = styled(Chip)(({theme}) => ({
    fontSize: 12,
    "& .MuiChip-label":{
        padding: '2px 5px 1px'
    },
    margin: '0px',
    borderRadius: '1px',
    color: '#fff'
}));

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    //textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};

function Resellers(props) {

    const classes = useStyles();
    const [currentSelectedPage, setCurrentSelectedPage] = useState(props.current_page);
    const [modalShow, setModalShow] = useState(false);
    const [myData, setMyData] = useState();
    const [deleteClient, setDeleteClient] = useState();
    const [months, setMonths] = useState("");
    //const [myData, setMyData] = useState();
    const [dataRows, setDataRows] = useState();
    const [filterText, setFilterText] = useState('');
    const [filterData, setFilterData] = useState([]);
    const [activeData, setActiveData] = useState([]);
    const [expiredData, setExpiredData] = useState([]);
    const [labelAll, setLabelAll] = useState("ALL");
    const [labelActive, setLabelActive] = useState("ACTIVE");
    const [labelExpired, setLabelExpired] = useState("EXPIRED");
    const [expanded, setExpanded] = React.useState(false);
    const [value, setValue] = React.useState('ALL');
    const theme = useTheme();
    const isSmallOrLess =
        useMediaQuery(theme.breakpoints.down('sm'));

    useEffect(() => {
        console.log('logging reseller list');
        props.onInitializeGetReseller();
        props.onInitializeAddReseller();
        props.onInitializeSaveReseller();
        props.onInitializeDeleteClient();
        props.onGetResellerList(props.token);

    }, []);

    useEffect(() => {
        console.log('logging dashboard client list');

        //props.onInitializeRetrieveCredits();
        //props.onGetClientList(props.token, currentSelectedPage, props.searchClients);

    }, [currentSelectedPage]);

    useEffect(() => {
        //console.log('select page: ', currentSelectedPage);
    }, [currentSelectedPage]);

    useEffect(() => {
        if (props.isDeleteClient.client){
            props.onGetResellerList(props.token);
            var successMessage = 'Deleted ' + props.isDeleteClient.client.name;
            props.onDisplaySnackbar({type: actionTypes.SNACKBAR_TYPE_SUCCESS, message: successMessage});

            setModalShow(false);
        }
    },[props.isDeleteClient.client]);

    useEffect(() => {
        if (props.isDeleteClient.error){
            var errorMessage = deleteClient + ": " + props.isDeleteClient.error;
            props.onDisplaySnackbar({type: actionTypes.SNACKBAR_TYPE_ERROR, message: errorMessage});

            setModalShow(false);
        }
    },[props.isDeleteClient.error]);

    const setCurrentReseller = (rowData) => {
        console.log('RESELLERS:: reseller name: ', rowData);
        props.onSetReseller(rowData.name);
        //props.onSetSuperReseller(rowData.manager);
        props.history.push('/updatereseller');
    };

    let clientsData = [];
    let data2 = {};
    let loadedData = null;
    let resellersData = [];
    useEffect(() => {
        if (props.resellers && props.resellers.length){
            resellersData = props.resellers.map((reseller) => {
                //console.log('inside client map', client);
                return {
                    name: reseller.reseller,
                    description: reseller.description,
                    //mac: client.mac,
                    credits: reseller.credits,
                    dealers: reseller.dealersCount,
                    clients: reseller.clientsCount
                };
            });
            setDataRows(resellersData);
            setFilterData(resellersData);
        }
    },[props.resellers]);

    useEffect(() => {
        //console.log('insided useEffect', filterText);
        if (dataRows && dataRows.length){
            //console.log('filter data', clientsData);
            let data = dataRows.filter(item => {
                if(item.name && item.name.toLowerCase().includes(filterText.toLowerCase())){
                    return true;
                } else if (item.mac && item.mac.toLowerCase().includes(filterText.toLowerCase())) {
                    return true;
                } else if (item.status && item.status.toLowerCase().includes(filterText.toLowerCase())) {
                    return true;
                } else if (item.description && item.description.toLowerCase().includes(filterText.toLowerCase())) {
                    return true;
                } else {
                    return false;
                }
            });
            setFilterData(data);
        }

    }, [filterText]);

    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    const handlePageChange = (e) => {
        //console.log('active page ', e.target.text);
        const page = e.target.text;
        if(page){
            if(page == 'First'){
                setCurrentSelectedPage(1);
            } else if(page == 'Last'){
                setCurrentSelectedPage(props.total_pages);
            } else {
                setCurrentSelectedPage(page);
            }
        }
    };


    const handleClose = () => setModalShow(false);

    const setModalClient = (client) => {
        setDeleteClient(client);
        console.log('logging delete client', deleteClient);
        setModalShow(true);
    };

    const handleDeleteClient = () => {
        console.log('deleting...', deleteClient);
        props.onDeleteReseller(props.token, deleteClient);
    };

    let items = [];

    let loading = (
        <Container>
            <Row>
                <Col></Col>
                <Col>
                    <Spinner animation="border" role="status">
                        <span className="sr-only">Loading...</span>
                    </Spinner>
                </Col>
                <Col></Col>
            </Row>
        </Container>
    );


    const dataColumnsMaterial = [

        {
            title: 'Reseller',
            field: 'name',
            render: (rowData) => <a href="#" onClick={() => setCurrentReseller(rowData)}>{rowData.name}</a>,
            cellStyle: {
                fontSize: 13,
                padding: '6px'
            }
        },
        {
            title: 'Description',
            field: 'description',
            cellStyle: {
                fontSize: 13,
                padding: '6px'
            }
        },
        {
            title: 'Dealers',
            field: 'dealers',
            cellStyle: {
                fontSize: 12,
                padding: '6px'
            }
        },
        {
            title: 'Clients',
            field: 'clients',
            cellStyle: {
                fontSize: 12,
                padding: '6px'
            }
        },
        {
            title: 'Credits',
            field: 'credits',
            cellStyle: {
                fontSize: 12,
                padding: '6px'
            }
        }
    ];

    const detailsPanel = [
        {
            disabled: !isSmallOrLess,
            render: (rowData) => {
                return (
                    <Box sx={{ ml: 2 }}>
                        <Stack direction="row" spacing={0}>
                            <Item>Status</Item>
                            <Item>
                                {rowData.rowData.status}
                            </Item>
                        </Stack>
                        <Stack direction="row" spacing={0}>
                            <Item>Ministra</Item>
                            <Item>
                                {rowData.rowData.ministra}
                            </Item>
                        </Stack>
                        <Stack direction="row" spacing={0}>
                            <Item>Desc</Item>
                            <Item>
                                {rowData.rowData.description}
                            </Item>
                        </Stack>
                        <Stack direction="row" spacing={1}>
                            <Item>Actions</Item>
                            {rowData.rowData.actions}
                        </Stack>
                    </Box>
                )
            }
        }
    ];

    //{
    //icon: tableIcons.Save,
    //    tooltip: 'Save User',
    //    onClick: (event, rowData) => props.history.push('/adminaddreseller')
    //},
    //{
    //icon: tableIcons.Delete,
    //    tooltip: 'Delete User',
    //onClick: (event, rowData) => props.history.push('/adminaddreseller')
    //}

    return (
        <>

            <Dialog
                open={modalShow}
                onClose={handleClose}
                aria-labelledby="contained-modal-title-vcenter"
            >
                <DialogTitle id="form-dialog-title">Delete?</DialogTitle>

                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete <b>{deleteClient}</b>?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button color="error" variant="contained" onClick={handleDeleteClient}>Yes</Button>
                    <Button color="primary" variant="contained"  onClick={handleClose}>Close</Button>
                </DialogActions>
            </Dialog>

            <Grid container spacing={2}>

                <Grid xs={12} md={12} item>

                    <Card>
                        <CardHeader
                            title="Manage Resellers"
                            titleTypographyProps={{
                                fontSize: 17,
                                fontWeight: 'bold'
                            }}
                        />
                        <Divider variant="middle" />
                        <CardContent sx={{p:1}}>
                            <MaterialTable
                                icons={tableIcons}
                                columns={dataColumnsMaterial}
                                data={filterData}
                                actions={[
                                    {
                                        icon: tableIcons.Add,
                                        tooltip: 'Add Reseller',
                                        isFreeAction: true,
                                        onClick: (event) => props.history.push('/addreseller')
                                    },
                                    {
                                        icon: tableIcons.Edit,
                                        tooltip: 'Edit User',
                                        onClick: (event, rowData) => setCurrentReseller(rowData)
                                    },
                                    {
                                        icon: tableIcons.Delete,
                                        tooltip: 'Delete User',
                                        onClick: (event, rowData) => setModalClient(rowData.name)
                                    },
                                ]}
                                title=""
                                options={{
                                    pageSize: 10,
                                    emptyRowsWhenPaging: false,
                                    pageSizeOptions: [10, 20, 30, 40, 50, 100],
                                    padding: "dense",
                                    headerStyle: {
                                        padding: '5px',
                                        fontWeight: 'bold',
                                        fontSize: 13,
                                        width: 26,
                                        whiteSpace: 'nowrap',
                                        flexDirection: 'row',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                    },
                                    tableLayout: "auto",
                                    actionsColumnIndex: -1,
                                    exportMenu: [{
                                        label: 'Export PDF',
                                        exportFunc: (dataColumnsMaterial, filterData) => ExportPdf(dataColumnsMaterial, filterData, 'myClients')
                                    }, {
                                        label: 'Export CSV',
                                        exportFunc: (dataColumnsMaterial, filterData) => ExportCsv(dataColumnsMaterial, filterData, 'myClients')
                                    }]
                                }}

                            />
                        </CardContent>
                    </Card>

                </Grid>
            </Grid>

        </>
    );
}

const mapDispatchToProps = dispatch => {
    return {
        onGetResellerList: (token) => dispatch(actions.resellerList(token)),
        onInitializeGetReseller: () => dispatch(actions.initializeGetReseller()),
        onInitializeAddReseller: () => dispatch(actions.initializeAddReseller()),
        onInitializeSaveReseller: () => dispatch(actions.initializeSaveReseller()),
        onInitializeDeleteClient: () => dispatch(actions.initializeDeleteClient()),
        onSetReseller: (name) => dispatch(actions.setReseller(name)),
        //onSetSuperReseller: (name) => dispatch(actions.setSuperReseller(name)),
        onDeleteReseller: (token, name) => dispatch(actions.deleteReseller(token, name)),
        onDisplaySnackbar: (message) => dispatch(actions.showSuccessSnackbar(message))

    }
};

const mapStateToProps = state => {
    return {
        token: state.auth.token,
        total: state.resellers.total,
        isLoading: state.resellers.loading,
        resellers: state.resellers.reseller_list,
        isDeleteClient: state.deleteClientReducer,
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Resellers);